export const SIRONA_SUPPORT_CHAT_URL =
  'https://static.zdassets.com/web_widget/latest/liveChat.html?v=10#key=sironamedical.zendesk.com';

export const openSironaSupportChat = () =>
  window.open(SIRONA_SUPPORT_CHAT_URL, '', 'noopener,noreferrer,height=600,width=500');
